// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2AIF8FFUbDA54O7SIfwGMq","row":"u-pQgBcOBmr38JwILwzRN"};